import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Routes from './Routes';
import Auth from './libs/Auth';
//import { URLSearchParams } from "url";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      isCustomerView: false,
      keyValue: '',
      path: ''
    };

    this.handleLogout = this.handleLogout.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.userHasAuthenticated = this.userHasAuthenticated.bind(this);
  }

  async componentDidMount() {
    let key = '';
    let path = '';
    let urlParams = null;

    if (this.props.location.search) {
      urlParams = new URLSearchParams(this.props.location.search);
    }

    if (urlParams && urlParams.get('key') && urlParams.get('path')) {
      key = urlParams.get('key');
      path = urlParams.get('path');
    } else if (localStorage.getItem('key') && localStorage.getItem('path')) {
      key = localStorage.getItem('key');
      path = localStorage.getItem('path');
    }

    try {
      await this.handleLogin(key, path);
    } catch (e) {
      console.log(e);
    }

    this.setState({ isAuthenticating: false });
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated, isAuthenticating: false });
  };

  async handleLogin(key, path) {
    try {
      if (key && path && (await Auth.authUser(key, path))) {
        this.userHasAuthenticated(true);
        localStorage.setItem('key', key);
        localStorage.setItem('path', path);
        this.setState({
          keyValue: key,
          path,
          isCustomerView: path.toLowerCase().indexOf('customer') > -1
        });
        return true;
      }
    } catch (e) {
      console.log(e);
    }

    return false;
  }

  handleLogout = event => {
    localStorage.removeItem('key');
    localStorage.removeItem('path');

    this.userHasAuthenticated(false);
    this.setState({ keyValue: '', path: '' });

    this.props.history.push('/login');
  };

  render() {
    const childProps = {
      userHasAuthenticated: this.userHasAuthenticated,
      handleLogout: this.handleLogout,
      handleLogin: this.handleLogin,
      ...this.state
    };

    return (
      !this.state.isAuthenticating && (
        <content>
          <Routes childProps={childProps} />
        </content>
      )
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js